import React from 'react';
import {connect} from 'react-redux';
import {Link} from "react-router-dom";
import {getCartItems} from '../../store/actions/cart';
import styles from './Header.module.css';
import {FaShoppingCart} from 'react-icons/fa';
import {getPortalSettings} from "../../store/actions/portalSettings";

class Header extends React.Component {
    state = {
        currentPage: ''
    };

    componentDidMount() {
        if (this.props.cart.length < 1) {
            this.props.getCartItems();
        }

        const subdomainAccountId = window.location.host.split('.')[1] ? window.location.host.split('.')[0] : false;
        console.log("domain ", subdomainAccountId);
        if (!this.props.portalSettings) {
            this.props.getPortalSettings(subdomainAccountId)
        }
    }

    render() {
        let portalSettings = this.props.portalSettings;

        if (!portalSettings) {
            return null
        }
        let headerBackgroundColor = {
            backgroundColor: portalSettings.header.headerBackgroundColorCode
        };
        let cartIconColor = {
            color: portalSettings.header.headerCartIconColor
        };



        const headerItems = [];

        const headerButtons = headerItems.map(item => {
            let currentStyle = styles.headerItems;
            if (item.title === this.state.currentPage) {
                currentStyle += ' ' + styles.active;
            }

            if (item.type === 'a') {
                return (
                    <a
                        href={item.url}
                        className={currentStyle}
                        onClick={() => this.setState({currentPage: item.title})}
                        key={item.title}
                    >
                        {item.title}
                    </a>
                );
            } else {
                return (
                    <Link
                        className={currentStyle}
                        onClick={() => this.setState({currentPage: item.title})}
                        to={item.url}
                        key={item.title}
                    >
                        {item.title}
                    </Link>
                );
            }
        });

        return (
            <div
                style={headerBackgroundColor}
                className={styles.header}>
                <div className={`${styles.container} ${styles.heading}`}>

                </div>
                <div className={styles.urlContainer}>
                    {headerButtons}
                </div>
                <div className={`${styles.container} ${styles.cartCount}`}>
                    <div className={styles.cartInfo}>
                        <Link to="/cart"
                              onClick={() => this.props.history.push('/cart')}
                              style={cartIconColor}
                              className={styles.link}>
                            <FaShoppingCart/>
                            <span className={styles.cartNumber}> {this.props.cart.length}</span>
                        </Link>
                    </div>
                    {/*<HamburgerMenu links={headerButtons}/>*/}
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    cart: state.cartReducer.cart,
    location: state.locationReducer.location,
    portalSettings: state.portalSettingsReducer.portalSettings
});

const mapDispatchToProps = dispatch => ({
    getCartItems: () => dispatch(getCartItems()),
    getPortalSettings: (accountId) => dispatch(getPortalSettings(accountId))

});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
